(function () {
  if (window.__fbpCurrencySwitcherLoaded) return;
  window.__fbpCurrencySwitcherLoaded = true;

  var STORAGE_KEY = 'fbp:display-currency';
  var RATES_CACHE_KEY = 'fbp:display-currency-rates';
  var RATES_URL = 'https://track.furrybodypillows.com/fx/v1/rates/latest';
  var LOAD_DELAY_MS = 1200;
  var RATES_CACHE_TTL_MS = 36 * 60 * 60 * 1000;
  var DEFAULT_SHELL_RIGHT_BOTTOM_PX = 18;
  var MOBILE_VISIBLE_CLEARANCE_PX = 24;
  var MOBILE_STICKY_MENU_SELECTORS = [
    '#shopify-section-mobile-sticky-menu ul.grid-wrap',
    '.mobile-sticky-menu ul.grid-wrap'
  ];
  var MOBILE_OBSTRUCTION_SELECTORS = [
    '#ajaxcart .footer-mini-cart.checkout-btn',
    '#ajaxcart .mini-cart-button',
    '#ajaxcart-checkout',
    '.mini-cart.drawer .footer-mini-cart.checkout-btn',
    '.mini-cart.drawer .mini-cart-button',
    '#fbp-sticky-atc.is-visible',
    '#stickyAtcBar',
    '.sticky-atc-bar',
    '#shopify-section-mobile-sticky-menu',
    '.mobile-sticky-menu',
    '#top',
    'a#top',
    'a.scroll#top',
    '#top.scroll',
    '.scroll#top'
  ];
  var SUPPORTED = {
    USD: { locale: 'en-US', label: 'USD', flagKey: 'USD', region: ['US'] },
    EUR: { locale: 'de-DE', label: 'EUR', flagKey: 'EUR', region: ['AT', 'BE', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK'] },
    CAD: { locale: 'en-CA', label: 'CAD', flagKey: 'CAD', region: ['CA'] },
    GBP: { locale: 'en-GB', label: 'GBP', flagKey: 'GBP', region: ['GB'] },
    AUD: { locale: 'en-AU', label: 'AUD', flagKey: 'AUD', region: ['AU'] },
    PLN: { locale: 'pl-PL', label: 'PLN', flagKey: 'PLN', region: ['PL'] }
  };
  var MONEY_SELECTOR = '.money';
  var state = {
    activeCurrency: 'USD',
    rates: null,
    observer: null,
    ready: false,
    scanQueued: false,
    productVariantMap: null
  };

  function shouldSkip() {
    return /\/checkouts|\/password|\/orders/.test(window.location.pathname);
  }

  function isVisibleElement(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function getMobileStickyMenuList() {
    for (var i = 0; i < MOBILE_STICKY_MENU_SELECTORS.length; i += 1) {
      var node = document.querySelector(MOBILE_STICKY_MENU_SELECTORS[i]);
      if (node) return node;
    }
    return null;
  }

  function findMobileStickyItemByTitle(list, title) {
    if (!list) return null;
    var targetTitle = String(title || '').trim().toLowerCase();
    var items = list.querySelectorAll('li.grid-wrapper');
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var label = (item.querySelector('.title') && item.querySelector('.title').textContent || '').trim().toLowerCase();
      if (label === targetTitle) return item;
    }
    return null;
  }

  function ensureMobileDockMountNode() {
    var list = getMobileStickyMenuList();
    if (!list) return null;

    var item = list.querySelector('.fbp-currency-grid-wrapper');
    if (!item) {
      item = document.createElement('li');
      item.className = 'grid-wrapper fbp-currency-grid-wrapper';
      item.innerHTML = '<div class="fbp-mobile-dock-slot fbp-mobile-currency-slot"></div>';

      var shopItem = findMobileStickyItemByTitle(list, 'shop');
      if (shopItem && shopItem.parentNode === list) {
        if (shopItem.nextSibling) {
          list.insertBefore(item, shopItem.nextSibling);
        } else {
          list.appendChild(item);
        }
      } else {
        list.insertBefore(item, list.firstChild);
      }
    }

    return item.querySelector('.fbp-mobile-currency-slot');
  }

  function collectMobileObstructionTop() {
    var seen = [];
    var top = null;
    for (var i = 0; i < MOBILE_OBSTRUCTION_SELECTORS.length; i += 1) {
      var nodes = document.querySelectorAll(MOBILE_OBSTRUCTION_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        var node = nodes[j];
        if (seen.indexOf(node) !== -1 || !isVisibleElement(node)) continue;
        seen.push(node);
        var rect = node.getBoundingClientRect();
        if (rect.bottom > window.innerHeight - 280) {
          top = top === null ? rect.top : Math.min(top, rect.top);
        }
      }
    }
    return top;
  }

  function injectStyles() {
    if (document.getElementById('fbp-currency-switcher-style')) return;
    var style = document.createElement('style');
    style.id = 'fbp-currency-switcher-style';
    style.textContent = [
      '.fbp-currency-shell{position:fixed;left:16px;bottom:18px;z-index:99995;display:flex;flex-direction:column;gap:6px;font-family:Urbanist,sans-serif;}',
      '.fbp-currency-row{display:flex;align-items:center;gap:8px;padding:8px 10px;border:1px solid rgba(18,24,38,.12);border-radius:999px;background:rgba(255,255,255,.94);box-shadow:0 10px 28px rgba(17,24,39,.14);backdrop-filter:blur(12px);}',
      '.fbp-currency-label{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6d7484;}',
      '.fbp-currency-label::before{content:none;}',
      '.fbp-currency-flag{display:inline-flex;align-items:center;justify-content:center;min-width:22px;height:22px;line-height:1;border-radius:999px;background:rgba(24,32,50,.06);overflow:hidden;}',
      '.fbp-currency-flag svg{display:block;width:16px;height:16px;border-radius:999px;box-shadow:0 0 0 1px rgba(24,32,50,.08) inset;}',
      '.fbp-currency-select{border:none;background:transparent;color:#182032;font-size:13px;font-weight:700;outline:none;cursor:pointer;padding-right:6px;font-family:Urbanist,"Segoe UI Emoji","Apple Color Emoji","Noto Color Emoji",sans-serif;}',
      '.fbp-currency-note{font-size:11px;color:#6d7484;padding-left:12px;}',
      '.fbp-currency-mobile{display:none;}',
      '.fbp-currency-mobile-toggle{display:inline-flex;align-items:center;justify-content:center;min-width:56px;height:42px;border:1px solid rgba(201,150,62,.34);border-radius:999px;background:rgba(255,255,255,.98);box-shadow:0 12px 28px rgba(17,24,39,.14);cursor:pointer;padding:0 12px;color:#1a1a2e !important;}',
      '.fbp-currency-mobile-toggle .fbp-currency-toggle-text{display:inline-flex;align-items:center;justify-content:center;font-size:12px;font-weight:800;letter-spacing:.06em;line-height:1;color:#1a1a2e !important;-webkit-text-fill-color:#1a1a2e !important;}',
      '.fbp-currency-mobile-panel{display:none;}',
      '.fbp-currency-shell.is-open .fbp-currency-mobile-panel{display:flex;}',
      '.fbp-currency-select-mobile{border:1px solid rgba(18,24,38,.12);background:rgba(255,255,255,.96);color:#182032;font-size:13px;font-weight:700;outline:none;cursor:pointer;padding:10px 12px;border-radius:12px;font-family:Urbanist,"Segoe UI Emoji","Apple Color Emoji","Noto Color Emoji",sans-serif;box-shadow:0 10px 28px rgba(17,24,39,.1);appearance:none;-webkit-appearance:none;}',
      '.fbp-currency-mobile-note{display:none;font-size:11px;line-height:1.45;color:#5b6272;}',
      '.fbp-currency-shell[data-mobile-note-visible="true"] .fbp-currency-mobile-note{display:block;}',
      '.fbp-currency-shell[data-currency="USD"] .fbp-currency-note{display:none;}',
      '[name="doubly-currencies"], .doubly-currency-switcher, .doubly-wrapper{display:none !important;}',
      '@media (max-width: 767px){.mobile-sticky-menu ul.grid-wrap{display:flex !important;align-items:stretch !important;justify-content:stretch !important;}.mobile-sticky-menu ul.grid-wrap li.grid-wrapper{flex:1 1 0 !important;width:auto !important;padding:10px 0 !important;}.mobile-sticky-menu ul.grid-wrap li.grid-wrapper:last-child{border-right:0 !important;}.mobile-sticky-menu a.icon-block,.mobile-sticky-menu button.icon-block{display:flex !important;align-items:center !important;justify-content:center !important;flex-direction:column !important;gap:5px;min-height:48px;width:100%;padding:0 6px;border:0;background:transparent;color:inherit;text-align:center;}.mobile-sticky-menu a.icon-block span.title,.mobile-sticky-menu button.icon-block span.title{font-size:11px;line-height:1.15;padding-top:0;white-space:nowrap;}.mobile-sticky-menu a.icon-block span.icon,.mobile-sticky-menu button.icon-block span.icon{font-size:18px;line-height:1;}.fbp-currency-shell{position:relative !important;top:auto !important;right:auto !important;left:auto !important;bottom:auto !important;z-index:12;width:100%;margin:0;padding:0;}.fbp-currency-shell[data-mount="pending-mobile"]{display:none !important;}.fbp-currency-row,.fbp-currency-note{display:none !important;}.fbp-mobile-currency-slot{display:flex;align-items:center;justify-content:center;width:100%;height:100%;}.fbp-currency-shell[data-mount="mobile-sticky-bar"] .fbp-currency-mobile{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:0;width:100%;height:100%;}.fbp-currency-shell[data-mount="mobile-sticky-bar"] .fbp-currency-mobile-toggle{min-width:0;width:100%;height:48px;padding:0 6px;border:0 !important;border-radius:0 !important;background:transparent !important;box-shadow:none !important;}.fbp-currency-shell[data-mount="mobile-sticky-bar"] .fbp-currency-mobile-toggle .fbp-currency-toggle-text{font-size:13px;letter-spacing:.03em;}.fbp-currency-shell[data-mount="mobile-sticky-bar"] .fbp-currency-mobile-panel{position:fixed;left:12px;right:12px;bottom:78px;display:none;flex-direction:column;gap:8px;padding:12px 14px;border:1px solid rgba(18,24,38,.12);border-radius:16px;background:rgba(255,255,255,.98);box-shadow:0 18px 42px rgba(17,24,39,.18);backdrop-filter:blur(14px);z-index:99998;}.fbp-currency-shell[data-mount="mobile-sticky-bar"].is-open .fbp-currency-mobile-panel{display:flex;}.fbp-currency-shell[data-mount="mobile-sticky-bar"] .fbp-currency-select-mobile{width:100%;min-width:0;max-width:none;font-size:13px;}.fbp-currency-shell[data-mount="mobile-sticky-bar"] .fbp-currency-mobile-note{display:none;}.fbp-currency-shell[data-mount="mobile-sticky-bar"][data-mobile-note-visible="true"] .fbp-currency-mobile-note{display:block;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function getFlagSvg(code) {
    switch (code) {
      case 'USD':
        return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="12" fill="#fff"/><path d="M0 4h24v2H0zm0 4h24v2H0zm0 4h24v2H0zm0 4h24v2H0zm0 4h24v2H0z" fill="#d22f27"/><path d="M0 0h12v12H0z" fill="#1f4aa8"/><circle cx="3" cy="3" r="1" fill="#fff"/><circle cx="6" cy="5" r="1" fill="#fff"/><circle cx="9" cy="3" r="1" fill="#fff"/><circle cx="4" cy="8" r="1" fill="#fff"/><circle cx="8" cy="8" r="1" fill="#fff"/></svg>';
      case 'EUR':
        return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="12" fill="#1f4aa8"/><circle cx="12" cy="5" r="1.1" fill="#f4c542"/><circle cx="16.5" cy="6.3" r="1.1" fill="#f4c542"/><circle cx="19" cy="10" r="1.1" fill="#f4c542"/><circle cx="19" cy="14" r="1.1" fill="#f4c542"/><circle cx="16.5" cy="17.7" r="1.1" fill="#f4c542"/><circle cx="12" cy="19" r="1.1" fill="#f4c542"/><circle cx="7.5" cy="17.7" r="1.1" fill="#f4c542"/><circle cx="5" cy="14" r="1.1" fill="#f4c542"/><circle cx="5" cy="10" r="1.1" fill="#f4c542"/><circle cx="7.5" cy="6.3" r="1.1" fill="#f4c542"/></svg>';
      case 'CAD':
        return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="12" fill="#fff"/><path d="M0 0h6v24H0zm18 0h6v24h-6z" fill="#d22f27"/><path d="M12 5l1.3 3.2H16l-2.2 1.9.8 3.1-2.6-1.5-2.6 1.5.8-3.1L8 8.2h2.7z" fill="#d22f27"/><path d="M12 11.8l1.5 2.7H12.7V17h-1.4v-2.5H10.5z" fill="#d22f27"/></svg>';
      case 'GBP':
        return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="12" fill="#1f4aa8"/><path d="M0 3l8 5.3V0h8v8.3L24 3v4l-6.7 4.5H24v1h-6.7L24 17v4l-8-5.3V24H8v-8.3L0 21v-4l6.7-4.5H0v-1h6.7L0 7z" fill="#fff"/><path d="M0 4.5l7 4.6v1.3L0 5.8zm24 0l-7 4.6v1.3l7-4.6zM0 19.5l7-4.6v-1.3L0 18.2zm24 0l-7-4.6v-1.3l7 4.6z" fill="#d22f27"/><path d="M10 0h4v10h10v4H14v10h-4V14H0v-4h10z" fill="#fff"/><path d="M10.8 0h2.4v10.8H24v2.4H13.2V24h-2.4V13.2H0v-2.4h10.8z" fill="#d22f27"/></svg>';
      case 'AUD':
        return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="12" fill="#1f4aa8"/><path d="M0 0h12v12H0z" fill="#143d8f"/><path d="M0 1l4.5 3V0h3v4L12 1v2L8.5 5.5H12v1H8.5L12 9v2L7.5 8V12h-3V8L0 11V9l3.5-2.5H0v-1h3.5L0 3z" fill="#fff"/><path d="M0 1.6l3.7 2.5v.7L0 2.3zm12 0L8.3 4.1v.7L12 2.3zM0 10.4l3.7-2.5v-.7L0 9.7zm12 0L8.3 7.9v-.7L12 9.7z" fill="#d22f27"/><path d="M4.8 0h2.4v4.8H12v2.4H7.2V12H4.8V7.2H0V4.8h4.8z" fill="#d22f27"/><circle cx="16.5" cy="8" r="1.4" fill="#fff"/><circle cx="18.8" cy="12" r="1.1" fill="#fff"/><circle cx="15.5" cy="14.7" r="1.2" fill="#fff"/><circle cx="20" cy="16.8" r="1.3" fill="#fff"/></svg>';
      case 'PLN':
        return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="12" fill="#fff"/><path d="M0 12h24v12H0z" fill="#d22f5a"/></svg>';
      default:
        return '';
    }
  }

  function getPreferredCurrency() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored && SUPPORTED[stored]) return stored;
    } catch (error) {}
    return 'USD';
  }

  function readCachedRates() {
    try {
      var raw = window.localStorage.getItem(RATES_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.rates || !parsed.savedAt) return null;
      if (Date.now() - Number(parsed.savedAt) > RATES_CACHE_TTL_MS) return null;
      if (!parsed.rates.USD) return null;
      return parsed.rates;
    } catch (error) {
      return null;
    }
  }

  function writeCachedRates(rates) {
    try {
      window.localStorage.setItem(RATES_CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        rates: rates
      }));
    } catch (error) {}
  }

  function queueScan() {
    if (state.scanQueued) return;
    state.scanQueued = true;
    window.requestAnimationFrame(function () {
      state.scanQueued = false;
      syncProductVariantPrices();
      convertAll(document);
    });
  }

  function isProductPage() {
    return Boolean(document.querySelector('form[action*="/cart/add"]'));
  }

  function formatUsdSource(value) {
    return '$' + Number(value || 0).toFixed(2) + ' USD';
  }

  function parseUsdText(text) {
    if (!text) return null;
    var normalized = String(text)
      .replace(/\u00a0/g, ' ')
      .replace(/USD/gi, '')
      .replace(/[^\d.,-]/g, '');
    if (!normalized) return null;

    if (normalized.indexOf(',') !== -1 && normalized.indexOf('.') !== -1) {
      normalized = normalized.replace(/,/g, '');
    } else if (normalized.indexOf(',') !== -1) {
      normalized = normalized.replace(',', '.');
    }

    var value = Number(normalized);
    return Number.isFinite(value) ? value : null;
  }

  function looksLikeUsdSourceText(text) {
    var trimmed = String(text || '').trim();
    if (!trimmed) return false;
    return /^\$\s*[\d.,-]+(?:\s*USD)?$/i.test(trimmed) || /^USD\s*[\d.,-]+$/i.test(trimmed);
  }

  function captureUsdBase(el) {
    var rawText = (el.textContent || '').trim();
    if (!rawText) return null;

    if (el.dataset.fbpUsdValue && !looksLikeUsdSourceText(rawText)) {
      return Number(el.dataset.fbpUsdValue);
    }

    if (!el.dataset.fbpUsdText || rawText !== el.dataset.fbpUsdText) {
      var parsed = parseUsdText(rawText);
      if (parsed == null) return null;
      el.dataset.fbpUsdValue = parsed.toFixed(2);
      el.dataset.fbpUsdText = rawText;
    }

    return Number(el.dataset.fbpUsdValue);
  }

  function setUsdBase(el, usdValue) {
    if (!el || !Number.isFinite(usdValue)) return;
    var fixed = Number(usdValue).toFixed(2);
    el.dataset.fbpUsdValue = fixed;
    el.dataset.fbpUsdText = formatUsdSource(usdValue);
  }

  function loadProductVariantMap() {
    if (!isProductPage()) return null;
    if (state.productVariantMap) return state.productVariantMap;

    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i += 1) {
      var raw = (scripts[i].textContent || '').trim();
      if (!raw || raw.charAt(0) !== '[') continue;
      try {
        var parsed = JSON.parse(raw);
        if (!Array.isArray(parsed) || !parsed.length) continue;
        if (typeof parsed[0].id === 'undefined' || typeof parsed[0].price === 'undefined') continue;
        state.productVariantMap = parsed.reduce(function (map, variant) {
          map[String(variant.id)] = variant;
          return map;
        }, {});
        return state.productVariantMap;
      } catch (error) {}
    }
    return null;
  }

  function getCurrentProductVariant() {
    var variantMap = loadProductVariantMap();
    if (!variantMap) return null;

    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var direct = idInput ? variantMap[String(idInput.value || '')] : null;
    if (direct) return direct;

    var selected = {};
    var selects = document.querySelectorAll('select[name^="options["]');
    for (var i = 0; i < selects.length; i += 1) {
      var key = 'option' + String(i + 1);
      selected[key] = selects[i].value || '';
    }

    var keys = Object.keys(variantMap);
    for (var j = 0; j < keys.length; j += 1) {
      var variant = variantMap[keys[j]];
      if (
        (!selected.option1 || variant.option1 === selected.option1) &&
        (!selected.option2 || variant.option2 === selected.option2) &&
        (!selected.option3 || variant.option3 === selected.option3)
      ) {
        return variant;
      }
    }
    return null;
  }

  function getProductPriceTargets() {
    var targets = document.querySelectorAll('.price-box .money, .price .money, .product-price .money');
    return Array.prototype.filter.call(targets, function (el) {
      return (el.textContent || '').trim() !== '';
    });
  }

  function syncProductVariantPrices() {
    if (!isProductPage()) return;
    var variant = getCurrentProductVariant();
    if (!variant || !Number.isFinite(Number(variant.price))) return;

    var targets = getProductPriceTargets();
    if (!targets.length) return;

    var primaryUsd = Number(variant.price) / 100;
    setUsdBase(targets[0], primaryUsd);

    if (targets[0].hasAttribute('doubly-currency-usd')) {
      targets[0].setAttribute('doubly-currency-usd', String(Number(variant.price)));
      targets[0].setAttribute('doubly-currency', 'USD');
    }

    if (targets.length > 1 && Number(variant.compare_at_price) > Number(variant.price)) {
      var compareUsd = Number(variant.compare_at_price) / 100;
      setUsdBase(targets[1], compareUsd);
      if (targets[1].hasAttribute('doubly-currency-usd')) {
        targets[1].setAttribute('doubly-currency-usd', String(Number(variant.compare_at_price)));
        targets[1].setAttribute('doubly-currency', 'USD');
      }
    }
  }

  function scheduleProductVariantSync() {
    var delays = [0, 180, 600, 1400];
    for (var i = 0; i < delays.length; i += 1) {
      window.setTimeout(queueScan, delays[i]);
    }
  }

  function bindProductVariantSync() {
    if (!isProductPage()) return;
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (target.matches('select[name^="options["], form[action*="/cart/add"] input[name="id"]')) {
        scheduleProductVariantSync();
      }
    });
  }

  function formatCurrency(value, currency) {
    var meta = SUPPORTED[currency] || SUPPORTED.USD;
    if (currency === 'CAD') {
      return 'CA$' + new Intl.NumberFormat('en-CA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }
    if (currency === 'AUD') {
      return 'A$' + new Intl.NumberFormat('en-AU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }
    return new Intl.NumberFormat(meta.locale, {
      style: 'currency',
      currency: currency,
      maximumFractionDigits: 2
    }).format(value);
  }

  function convertElement(el) {
    if (!el || el.closest('script,style,noscript,template')) return;
    var usdValue = captureUsdBase(el);
    if (usdValue == null) return;

    if (state.activeCurrency === 'USD' || !state.rates || !state.rates[state.activeCurrency]) {
      el.textContent = el.dataset.fbpUsdText;
      el.dataset.fbpDisplayCurrency = 'USD';
      return;
    }

    var converted = usdValue * state.rates[state.activeCurrency];
    el.textContent = formatCurrency(converted, state.activeCurrency);
    el.dataset.fbpDisplayCurrency = state.activeCurrency;
  }

  function convertAll(root) {
    if (!root) return;
    var nodes = root.querySelectorAll ? root.querySelectorAll(MONEY_SELECTOR) : [];
    for (var i = 0; i < nodes.length; i += 1) {
      convertElement(nodes[i]);
    }
    syncShellState();
  }

  function applyCurrencyFieldStyles(shell) {
    var target = shell || document.querySelector('.fbp-currency-shell');
    if (!target) return;

    Array.prototype.forEach.call(target.querySelectorAll('.fbp-currency-row'), function (row) {
      row.style.setProperty('background', 'rgba(255,255,255,0.96)', 'important');
      row.style.setProperty('background-color', 'rgba(255,255,255,0.96)', 'important');
      row.style.setProperty('border', '1px solid rgba(18,24,38,0.12)', 'important');
    });

    Array.prototype.forEach.call(target.querySelectorAll('.fbp-currency-select, .fbp-currency-select-mobile'), function (select) {
      select.style.setProperty('background', 'rgba(255,255,255,0.96)', 'important');
      select.style.setProperty('background-color', 'rgba(255,255,255,0.96)', 'important');
      select.style.setProperty('color', '#1a1a2e', 'important');
      select.style.setProperty('-webkit-text-fill-color', '#1a1a2e', 'important');
      select.style.setProperty('border', '1px solid rgba(26,10,46,0.16)', 'important');
      select.style.setProperty('border-radius', '12px', 'important');
      select.style.setProperty('box-shadow', '0 8px 20px rgba(26,10,46,0.05)', 'important');
      select.style.setProperty('appearance', 'none', 'important');
      select.style.setProperty('-webkit-appearance', 'none', 'important');
      select.style.setProperty('color-scheme', 'light', 'important');
      select.style.setProperty('opacity', '1', 'important');
    });
  }

  function hardenShellVisibility(shell) {
    var target = shell || document.querySelector('.fbp-currency-shell');
    if (!target) return;

    target.style.setProperty('opacity', '1', 'important');
    target.style.setProperty('visibility', 'visible', 'important');
    target.style.setProperty('pointer-events', 'auto', 'important');
    target.style.setProperty('transform', 'none', 'important');
    target.style.setProperty('filter', 'none', 'important');

    var toggle = target.querySelector('.fbp-currency-mobile-toggle');
    if (toggle) {
      toggle.style.setProperty('opacity', '1', 'important');
      toggle.style.setProperty('visibility', 'visible', 'important');
      toggle.style.setProperty('display', 'inline-flex', 'important');
      toggle.style.setProperty('color', '#1a1a2e', 'important');
      toggle.style.setProperty('-webkit-text-fill-color', '#1a1a2e', 'important');
      if (target.dataset.mount === 'mobile-sticky-bar') {
        toggle.style.setProperty('background', 'transparent', 'important');
        toggle.style.setProperty('background-color', 'transparent', 'important');
        toggle.style.setProperty('border', '0', 'important');
        toggle.style.setProperty('box-shadow', 'none', 'important');
      } else {
        toggle.style.setProperty('background', 'rgba(255,255,255,0.98)', 'important');
        toggle.style.setProperty('background-color', 'rgba(255,255,255,0.98)', 'important');
        toggle.style.setProperty('border', '1px solid rgba(201,150,62,0.34)', 'important');
      }
    }

    var toggleText = target.querySelector('.fbp-currency-toggle-text');
    if (toggleText) {
      toggleText.style.setProperty('opacity', '1', 'important');
      toggleText.style.setProperty('visibility', 'visible', 'important');
      toggleText.style.setProperty('color', '#1a1a2e', 'important');
      toggleText.style.setProperty('-webkit-text-fill-color', '#1a1a2e', 'important');
    }
  }

  function setMobileShellOpen(nextOpen) {
    var shell = document.querySelector('.fbp-currency-shell');
    if (!shell) return;
    var isOpen = Boolean(nextOpen);
    shell.classList.toggle('is-open', isOpen);
    shell.setAttribute('data-mobile-open', isOpen ? 'true' : 'false');
    var toggle = shell.querySelector('.fbp-currency-mobile-toggle');
    if (toggle) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
    var panel = shell.querySelector('.fbp-currency-mobile-panel');
    if (panel) {
      panel.hidden = !isOpen;
    }
    hardenShellVisibility(shell);
  }

  function openMobileSelector(shell) {
    var target = shell || document.querySelector('.fbp-currency-shell');
    if (!target) return;
    setMobileShellOpen(true);
    var select = target.querySelector('.fbp-currency-select-mobile');
    if (!select) return;
    try {
      select.focus();
    } catch (error) {}
  }

  function ensureShellMount(shell) {
    var target = shell || document.querySelector('.fbp-currency-shell');
    if (!target) return null;

    if (isMobileViewport()) {
      var mount = ensureMobileDockMountNode();
      if (mount) {
        if (target.parentNode !== mount) {
          mount.appendChild(target);
        }
        target.dataset.mount = 'mobile-sticky-bar';
        hardenShellVisibility(target);
        return target;
      }

      if (target.parentNode !== document.body) {
        document.body.appendChild(target);
      }
      target.dataset.mount = 'pending-mobile';
      hardenShellVisibility(target);
      return target;
    }

    if (target.parentNode !== document.body) {
      document.body.appendChild(target);
    }
    target.dataset.mount = 'body';
    hardenShellVisibility(target);
    return target;
  }

  function syncShellState() {
    var shell = ensureShellMount(document.querySelector('.fbp-currency-shell'));
    if (!shell) return;
    applyCurrencyFieldStyles(shell);
    shell.dataset.currency = state.activeCurrency;
    var flagMarkup = getFlagSvg((SUPPORTED[state.activeCurrency] && SUPPORTED[state.activeCurrency].flagKey) || state.activeCurrency);
    Array.prototype.forEach.call(shell.querySelectorAll('.fbp-currency-flag'), function (flag) {
      flag.innerHTML = flagMarkup;
    });
    Array.prototype.forEach.call(shell.querySelectorAll('.fbp-currency-select, .fbp-currency-select-mobile'), function (select) {
      if (select.value !== state.activeCurrency) {
        select.value = state.activeCurrency;
      }
    });
    var toggle = shell.querySelector('.fbp-currency-mobile-toggle');
    if (toggle) {
      toggle.setAttribute('aria-label', 'Display currency: ' + state.activeCurrency);
    }
    var toggleText = shell.querySelector('.fbp-currency-toggle-text');
    if (toggleText) {
      toggleText.textContent = state.activeCurrency;
    }
    shell.dataset.mobileNoteVisible = state.activeCurrency === 'USD' ? 'false' : 'true';
    applyShellPlacement(shell);
  }

  function applyShellPlacement(shell) {
    var target = ensureShellMount(shell || document.querySelector('.fbp-currency-shell'));
    if (!target) return;
    hardenShellVisibility(target);
    if (isMobileViewport()) {
      target.style.left = '';
      target.style.bottom = '';
      return;
    }
    target.style.left = '16px';
    target.style.bottom = DEFAULT_SHELL_RIGHT_BOTTOM_PX + 'px';
  }

  function bindMutationObserver() {
    if (state.observer) return;
    state.observer = new MutationObserver(function () {
      queueScan();
    });
    state.observer.observe(document.documentElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
    window.addEventListener('resize', queueScan, { passive: true });
  }

  function onCurrencyChange(nextCurrency) {
    if (!SUPPORTED[nextCurrency]) return;
    state.activeCurrency = nextCurrency;
    try {
      window.localStorage.setItem(STORAGE_KEY, nextCurrency);
    } catch (error) {}
    queueScan();
  }

  function createShell() {
    if (document.querySelector('.fbp-currency-shell')) return;
    injectStyles();
    var optionsHtml = Object.keys(SUPPORTED).map(function (code) {
      return '<option value="' + code + '">' + SUPPORTED[code].label + '</option>';
    }).join('');

    var shell = document.createElement('div');
    shell.className = 'fbp-currency-shell';
    shell.innerHTML = [
      '<div class="fbp-currency-row">',
      '<span class="fbp-currency-label">Currency</span>',
      '<span class="fbp-currency-flag" aria-hidden="true"></span>',
      '<select class="fbp-currency-select" aria-label="Display currency">',
      optionsHtml,
      '</select>',
      '</div>',
      '<div class="fbp-currency-note">Display only. Checkout stays in USD.</div>',
      '<div class="fbp-currency-mobile">',
      '<button class="fbp-currency-mobile-toggle" type="button" aria-expanded="false" aria-label="Display currency">',
      '<span class="fbp-currency-toggle-text" aria-hidden="true">USD</span>',
      '</button>',
      '<div class="fbp-currency-mobile-panel" hidden>',
      '<select class="fbp-currency-select-mobile" aria-label="Display currency">',
      optionsHtml,
      '</select>',
      '<div class="fbp-currency-mobile-note">Display only. Checkout stays in USD.</div>',
      '</div>',
      '</div>'
    ].join('');

    Array.prototype.forEach.call(shell.querySelectorAll('.fbp-currency-select, .fbp-currency-select-mobile'), function (select) {
      select.addEventListener('change', function (event) {
        onCurrencyChange(event.target.value);
        if (select.classList.contains('fbp-currency-select-mobile')) {
          setMobileShellOpen(false);
        }
      });
      select.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });

    var mobileToggle = shell.querySelector('.fbp-currency-mobile-toggle');
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (shell.classList.contains('is-open')) {
          setMobileShellOpen(false);
          return;
        }
        openMobileSelector(shell);
      });
    }

    document.addEventListener('click', function (event) {
      if (!isMobileViewport()) return;
      if (!shell.classList.contains('is-open')) return;
      if (shell.contains(event.target)) return;
      setMobileShellOpen(false);
    }, true);

    document.body.appendChild(shell);
    setMobileShellOpen(false);
    applyCurrencyFieldStyles(shell);
    hardenShellVisibility(shell);
    syncShellState();
  }

  async function fetchRates() {
    var response = await fetch(RATES_URL, {
      credentials: 'omit',
      headers: {
        'accept': 'application/json'
      }
    });
    if (!response.ok) {
      throw new Error('Currency rates request failed with ' + response.status);
    }
    var payload = await response.json();
    if (!payload || !payload.rates || !payload.rates.USD) {
      throw new Error('Currency rates payload was invalid');
    }
    state.rates = payload.rates;
    writeCachedRates(payload.rates);
  }

  async function init() {
    if (shouldSkip() || state.ready) return;
    state.ready = true;
    state.activeCurrency = getPreferredCurrency();
    state.rates = readCachedRates();
    createShell();
    bindProductVariantSync();
    bindMutationObserver();
    syncProductVariantPrices();
    convertAll(document);

    try {
      await fetchRates();
      queueScan();
    } catch (error) {
      console.error('FBP currency switcher failed to load rates', error);
      if (!state.rates) {
        state.activeCurrency = 'USD';
        queueScan();
      }
    }
  }

  function scheduleInit() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () {
        window.setTimeout(init, LOAD_DELAY_MS);
      }, { timeout: LOAD_DELAY_MS + 1200 });
      return;
    }
    window.setTimeout(init, LOAD_DELAY_MS);
  }

  if (document.readyState === 'complete') {
    scheduleInit();
  } else {
    window.addEventListener('load', scheduleInit, { once: true });
  }
})();
